import React from "react";
import { Info } from "@piiqtechnologies/svg-icons";
import { PeekBox, PeekStack, PeekTooltip, PeekTypography } from "@piiqtechnologies/ui-components";
import { CategoryIcon } from "@utils/utils";
import CategoryCardStatusChip from "./CategoryCardStatusChip";
export const CategoryCardTitle = ({ categoryType, categoryName, categoryChange, categoryIcon, isCategoryReviewPositive, titleInfoTooltip, }) => {
    return (React.createElement(PeekStack, { direction: "row", spacing: 0.5, alignItems: "center" },
        categoryIcon ? categoryIcon : React.createElement(CategoryIcon, { categoryType: categoryType }),
        React.createElement(PeekTypography, { variant: "h2", fontWeight: "fontWeightLight" }, categoryName),
        titleInfoTooltip && (React.createElement(PeekTooltip, { title: titleInfoTooltip, placement: "bottom" },
            React.createElement(PeekBox, { sx: { display: "inline-flex", fontSize: 16 } },
                React.createElement(Info, { width: "1em", height: "1em" })))),
        React.createElement(CategoryCardStatusChip, { categoryChange: categoryChange, isCategoryReviewPositive: isCategoryReviewPositive })));
};
export default CategoryCardTitle;
